import { useMemo } from "react";

export default function useMasonryLayout(videos, columns = 4) {
    return useMemo(() => {
        const cols = Array.from({ length: columns }, () => []);
        const heights = Array(columns).fill(0);

        videos.forEach((video, index) => {
            const minIndex = heights.indexOf(Math.min(...heights));
            cols[minIndex].push({ ...video, index });
            heights[minIndex] += video.height + 14;
        });

        return cols;
    }, [videos, columns]);
}
